import React, { Component } from 'react';
import {
    Link,
    Redirect
} from "react-router-dom";
import { Formik } from 'formik';
import _ from 'lodash';
import config from '../config';
import JsonEditorComponent from '../JsonEditorComponent'
import {AuthContext} from "../context/auth";
import fetcher from "../context/fetcher";
import {downloadFile, readFileAsync} from "../components/ImportExport";

export default class Events extends Component {
    static contextType = AuthContext
    constructor(props, context) {
        super(props);
        this.authContext = context;
        this.state = {};
        this.init = this.init.bind(this);
        this.remove = this.remove.bind(this);
        this.disable = this.disable.bind(this);
        this.exportObjs = this.exportObjs.bind(this);
        this.importObjs = this.importObjs.bind(this);
        this.init();
    }

    async init(request)  {
        console.log(request)
        fetcher(`${config.API()}collection/notifications`)
        .then(response => response.json())
        .then(notifications => {
            this.setState({notifications})

            fetcher(`${config.API()}webplugin/get_notifications`)
                .then(response => response.json())
                .then(response => {
                    if(response.data) {
                        for (let e of notifications) {
                            let ev = _.find(response.data, x => x.id == e._id);
                            if(ev)
                            {
                                e["isActive"] = ev["isActive"]
                                e["startTime"] = ev["startTime"]
                                e["endTime"] = ev["endTime"]
                            }
                        }
                        this.setState({notifications: notifications})
                    }
                });
        });
    }

    disable = (values) => {
        return () => {
            if(!values.hasOwnProperty("disable"))
                values.disable = false;

            values.disable = !values.disable
            let body = JSON.stringify(values);
            fetcher(`${config.API()}collection/notifications/save`,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body
            })
                .then(response => response.json())
                .then(data => {
                    this.init();
                });
        }
    }

    remove = (contestId) => {
        return (e) => {
            let isOk = window.confirm("Are you sure?");
            if(!isOk)
                return;
            fetcher(`${config.API()}collection/notifications/remove/${contestId}`,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body:"{}"
            })
            .then(response => response.json())
            .then(data => {
                let notifications = this.state.notifications;
                _.remove(notifications, x => x._id == contestId)
                this.setState({notifications})
            });
        }
    }

    linkToEdit = (contestId) => {
        return () => {
            this.setState({redirect: `/notifications/${contestId}`});
        }
    }
    exportObjs = () => downloadFile(JSON.stringify(this.state.notifications, null, "\t"), "notifications.json", 'text/plain')

    importObjs = async (e) => {
        let text = await readFileAsync(e)
        let objs = JSON.parse(text)
        this.setState({notifications: objs})
        await fetcher(`${config.API()}collection/notifications/import`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: text
        })
    }
    render() {

        if (this.state.redirect) {
            return <Redirect push to={this.state.redirect} />;
        }
        return (
            <div>
            <div className="card shadow w100">
                <div className="card-header py-3">
                    <h2 className="m-0 font-weight-bold l"> Notifications </h2>
                    <input onChange={this.importObjs} type="file" id="file-input" className="r btn btn-icon btn-light ml-1"/>
                    <button onClick={this.exportObjs} className="r btn btn-icon btn-light  ml-1"><i className="fas fa-fw fa-arrow-circle-down "></i> Export </button>
                </div>
                <div className="card-body">
                    <div className="table-responsive">
                        <table className="dataTable table table-align-middle table-bordered table-sm" width="100%"
                               cellSpacing="0">
                            <thead>
                            <tr>
                                <th>Id</th>
                                <th>Title</th>
                                <th>Text</th>
                                <th>Start</th>
                                <th>End</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.notifications && this.state.notifications.map((x,i) =>
                                <tr className={(x.isActive ? "active" : "")} key={x._id} >
                                    <td><button className={`btn ${x.disable ? "btn-outline-danger" : "btn-outline-primary"} btn-circle btn-sm`} onClick={this.disable(x)} ><i className={`fa ${x.disable ? "fa-toggle-off" : "fa-toggle-on"}`}></i></button></td>
                                    <td>{x._id}</td>
                                    <td>{x.title}</td>
                                    <td>{x.text}</td>
                                    <td>{x.startTime}</td>
                                    <td>{x.endTime}</td>
                                    <td>
                                        <button className="btn btn-outline-danger btn-circle btn-sm" onClick={this.remove(x._id)} ><i className="fa fa-remove"></i></button>
                                        <button className="btn btn-outline-primary btn-circle btn-sm" onClick={this.linkToEdit(x._id)} ><i className="fa fa-edit"></i></button>
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                    <div className="r">
                        <button onClick={this.linkToEdit("new")} className="btn btn-icon btn-primary ml-1"><i className="fas fa-fw fa-plus-square"></i> Add </button>
                    </div>
                </div>
            </div>

            </div>
        );
    }
}
